import { PERMISSION_NAMES } from '../../../constants/permissionNames';

export const OWNER_PERMISSIONS = [
  PERMISSION_NAMES.ROLE_DELETE,
  PERMISSION_NAMES.ROLE_CREATE,
  PERMISSION_NAMES.ROLE_ASSIGN,
  PERMISSION_NAMES.CHANNEL_CREATE,
  PERMISSION_NAMES.CHANNEL_READ,
  PERMISSION_NAMES.CHANNEL_UPDATE,
  PERMISSION_NAMES.CHANNEL_DELETE,
  PERMISSION_NAMES.CHANNEL_MANAGE,
  PERMISSION_NAMES.MEMBER_CREATE,
  PERMISSION_NAMES.MEMBER_DELETE,
  PERMISSION_NAMES.MEMBER_BROWSE,
  PERMISSION_NAMES.STREAMITEM_CREATE,
  PERMISSION_NAMES.STREAMITEM_READ,
  PERMISSION_NAMES.STREAMITEM_UPDATE,
  PERMISSION_NAMES.STREAMITEM_DELETE,
  PERMISSION_NAMES.STREAMITEM_BROWSE,
  PERMISSION_NAMES.STREAMITEM_TAG,
  PERMISSION_NAMES.STREAMITEM_PUBLISH,
  PERMISSION_NAMES.COMMENT_CREATE,
  PERMISSION_NAMES.COMMENT_DELETE,
  PERMISSION_NAMES.STREAM_CREATE,
  PERMISSION_NAMES.STREAM_UPDATE,
  PERMISSION_NAMES.STREAM_DELETE,
  PERMISSION_NAMES.INVITE_CREATE,
  PERMISSION_NAMES.INVITE_DELETE,
  PERMISSION_NAMES.INVITE_BROWSE,
  PERMISSION_NAMES.ORG_CREATE,
  PERMISSION_NAMES.ORG_READ,
  PERMISSION_NAMES.ORG_UPDATE,
  PERMISSION_NAMES.STREAM_READ,
  PERMISSION_NAMES.STREAM_UPDATE,
  PERMISSION_NAMES.STREAMITEM_TIMELINE_SEND,
];
